<xemex-table
  [data]="tableData()"
  [columns]="columns"
  [loading]="isLoading()"
  [totalCount]="users().numberOfItems || undefined"
  [pageSize]="pageSize"
  (pageChange)="onPageChange($event)"
>
  @if (permissions().includes('create_new_users')) {
    <div class="flex justify-end">
      <xemex-filled-button icon="add" (click)="onCreateUser()">
        {{ 'companies.users.addUser' | translate }}
      </xemex-filled-button>
    </div>
  }

  @if (hasAnyAction()) {
    <ng-template #actionsCell let-row>
      @if (
        permissions().includes('edit_user_details') ||
        permissions().includes('delete_users') ||
        (permissions().includes('create_new_users') && row['status'] !== 'Active')
      ) {
        <button class="users-table-action" mat-icon-button [matMenuTriggerFor]="userMenu">
          <mat-icon class="users-table-action__icon text-gray-500">more_vert</mat-icon>
        </button>
        <mat-menu #userMenu="matMenu">
          @if (permissions().includes('create_new_users') && row['status'] !== 'Active') {
            <button (click)="onResendInvite(row['objectId'])" mat-menu-item>
              {{ 'resendInvite.menuButton' | translate }}
            </button>
          }
          @if (permissions().includes('edit_user_details')) {
            <button (click)="onEditUser(row['objectId'])" mat-menu-item>
              {{ 'editUser.menuButton' | translate }}
            </button>
          }
          @if (permissions().includes('delete_users')) {
            <button (click)="onDeleteUser(row['objectId'])" mat-menu-item style="color: red">
              {{ 'general.btnDelete' | translate }}
            </button>
          }
        </mat-menu>
      }
    </ng-template>
  }
</xemex-table>
